var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.currentSaved
    ? _c(
        "div",
        { staticClass: "form-group", on: { keydown: _vm.onHandleKeyDown } },
        [
          !_vm.isSelectedNewFeedback
            ? _c("input", {
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  placeholder: _vm.T.runDetailsFeedbackThreadPlaceholder,
                },
                on: {
                  click: function ($event) {
                    _vm.isSelectedNewFeedback = true
                  },
                },
              })
            : _c("div", { staticClass: "card" }, [
                _c(
                  "div",
                  { staticClass: "card-header" },
                  [
                    _c("omegaup-user-username", {
                      attrs: {
                        classname: _vm.currentFeedbackThread.authorClassname,
                        username: _vm.currentFeedbackThread.author,
                        linkify: true,
                      },
                    }),
                    _c(
                      "button",
                      {
                        staticClass: "close btn-sm",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.onDeleteFeedbackThread.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      },
                      [_vm._v(" ❌ ")]
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "card-body" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentFeedbackThread.text,
                        expression: "currentFeedbackThread.text",
                      },
                    ],
                    ref: "feedback-thread-form",
                    staticClass: "w-100",
                    attrs: {
                      placeholder: _vm.T.runDetailsFeedbackThreadPlaceholder,
                    },
                    domProps: { value: _vm.currentFeedbackThread.text },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.currentFeedbackThread,
                          "text",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _c("div", { staticClass: "card-footer text-muted" }, [
                  _c("div", { staticClass: "form-group my-2" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary mx-2",
                        attrs: {
                          "data-button-submit": "",
                          disabled: !_vm.currentFeedbackThread.text,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.onSubmitFeedback.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.T.runDetailsFeedbackAddReview) + " "
                        ),
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-danger mx-2",
                        attrs: { "data-button-cancel": "" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.onDeleteFeedbackThread.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.T.runDetailsFeedbackCancel) + " "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
        ]
      )
    : _c("div", { staticClass: "card" }, [
        _c(
          "div",
          { staticClass: "card-header" },
          [
            _c("omegaup-user-username", {
              attrs: {
                classname: _vm.currentFeedbackThread.authorClassname,
                username: _vm.currentFeedbackThread.author,
                linkify: true,
              },
            }),
            _vm._v(" " + _vm._s(_vm.currentFeedbackThreadTimestamp) + " "),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c("omegaup-markdown", {
              attrs: {
                markdown: _vm.currentFeedbackThread.text,
                "full-width": true,
              },
            }),
          ],
          1
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }